import _typeof from "@babel/runtime/helpers/esm/typeof";
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
import { c as _c } from "react-compiler-runtime";
import React, { Suspense } from 'react';
import { getIsItemAddedModalOpen } from "../../store/item-added-modal/selectors";
import useItemAddedModalStore from "../../store/item-added-modal/use-store";

/* Eagerly start chunk downloads at module load time (when ShopApp renders)
   rather than deferring until the store triggers the modal open. This
   eliminates the cold network fetch from the critical path between the
   user's "Add to Cart" action and the modal becoming visible. The promises
   resolve in the background; React.lazy reuses them so Suspense resolves
   instantly if the chunk has already arrived. */
var cartModalImport = Promise.resolve().then(function () {
  return _interopRequireWildcard(require('./cart/CartItemAddedModal'));
});
var wishlistModalImport = Promise.resolve().then(function () {
  return _interopRequireWildcard(require('./wishlist/WishlistItemAddedModal'));
});

// Prevent unhandled-rejection events if a chunk fetch fails before
// React.lazy consumes the promise. The no-op handler marks the promise as
// "handled" for the browser; React.lazy still receives the original
// promise and will propagate the error through the Suspense error boundary.
cartModalImport["catch"](function () {});
wishlistModalImport["catch"](function () {});
var LazyCartItemAddedModal = /*#__PURE__*/React.lazy(function () {
  return cartModalImport;
});
var LazyWishlistItemAddedModal = /*#__PURE__*/React.lazy(function () {
  return wishlistModalImport;
});
var ItemAddedModalWrapper = function ItemAddedModalWrapper() {
  var $ = _c(2);
  var shouldOpenModal = useItemAddedModalStore(getIsItemAddedModalOpen);
  var modalType_0 = useItemAddedModalStore(_temp);
  if (!shouldOpenModal) {
    return null;
  }
  var t0;
  if ($[0] !== modalType_0) {
    t0 = /*#__PURE__*/React.createElement(Suspense, {
      fallback: null
    }, modalType_0 === "favorites" ? /*#__PURE__*/React.createElement(LazyWishlistItemAddedModal, null) : /*#__PURE__*/React.createElement(LazyCartItemAddedModal, null));
    $[0] = modalType_0;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default ItemAddedModalWrapper;
function _temp(t0) {
  var modalType = t0.modalType;
  return modalType;
}